"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _Pdf = _interopRequireDefault(require("@/components/Pdf"));
var _utils = require("@/utils");
var _vuex = require("vuex");
var _GlImageViewer = _interopRequireDefault(require("@/componentsBuz/GlImageViewer"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    dragDialog: _DragDialog.default,
    pdf: _Pdf.default,
    GlImageViewer: _GlImageViewer.default,
    TreeSelect: _vueTreeselect.default
  },
  props: {
    fileListArray: {
      type: Array
    },
    limitUpload: {
      type: Number,
      default: 1
    },
    isSupplyDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pdfVisible: false,
      pdfUrl: '',
      dialogVisible: false,
      showTitle: true,
      showUpload: true,
      showOption: true,
      imgSrcList: [],
      pdfTitle: '',
      downloadDisable: '',
      isShow: false,
      deletefileKey: [],
      fileList: [],
      loading: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo', 'btnPermissions'])),
  watch: {},
  beforeCreate: function beforeCreate() {
    // that = this;
  },
  created: function created() {},
  methods: {
    handleGetDownloadFile: function handleGetDownloadFile() {
      var _this = this;
      (0, _booking.downloadFile)(this.fileKey).then(function (res) {
        if (res.success) {
          var url = window.URL.createObjectURL(new Blob([res.data]));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', _this.fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          _this.$message.error(res.errorMessages[0]);
        }
      });
    },
    uploadFile: function uploadFile(item) {
      var _this2 = this;
      if (this.fileList.length < 1) {
        this.loading = (0, _utils.load)();
        var formDatas = new FormData();
        formDatas.append("file", item.file);
        formDatas.append("bucket", 'commerce');
        (0, _booking.setUploadFile)(formDatas).then(function (res) {
          if (res.code) {
            _this2.fileKey = res.fileId;
            _this2.fileName = res.fileName;
            _this2.fileList = [{
              fileName: res.fileName,
              createdDtmLoc: (0, _utils.parseTime)(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
              fileKey: res.fileId
            }];
            _this2.$parent.handleGetFileList();
            _this2.$message.success(_this2.$t("home.uploadTitleSuccess"));
          } else {
            _this2.$message.warning(res.errorMessages[0]);
          }
        }).finally(function () {
          _this2.loading.close();
        });
      } else {
        this.$message.warning(this.$t('home.fileMessageTwo'));
      }
    },
    showName: function showName(arr, id) {
      var _this3 = this;
      if (arr instanceof Array) {
        var label = '';
        arr.some(function (item) {
          if (item.codeValue === id) {
            label = _this3.language === 'zh' ? item.displayValueCn : item.displayValue;
            return true;
          }
        });
        return label;
      }
    },
    beforeRemove: function beforeRemove(file, fileList) {
      // this.editRow.delFlag = true
      return this.$confirm("".concat(this.$t('com.confirmremoval'), " ").concat(file.name, "\uFF1F"));
    },
    /* 显示原图 */showOriginImage: function showOriginImage(idx, url) {
      this.imgSrcList[idx].isOrigin = true;
      this.imgSrcList[idx].url = url;
    },
    /* 申请重发原图 */applyTransfer: function applyTransfer(idx) {
      this.imgSrcList[idx].istransfer = '1';
    },
    /* 点击附件上传 */handleUpload: function handleUpload() {
      if (this.beforeUpload()) {
        this.showFileList = [];
        this.dialogVisible = true;
        // this.$nextTick(function() {
        //   this.$refs.uploadBtn.$el.click();
        // });
        this.status = 'add';
      }
    },
    closeEdit: function closeEdit() {
      this.status = 'add';
    },
    handleNoDialogUpload: function handleNoDialogUpload() {
      if (this.beforeUpload()) {
        this.$nextTick(function () {
          this.$refs.uploadNoDialogBtn.$el.click();
        });
      }
    },
    opened: function opened() {
      this.fileList = this.fileListArray.filter(function (item) {
        return item.rowStatus !== 8;
      });
    },
    /* 文件大小超出校验 */beforeFileUpload: function beforeFileUpload(file) {
      console.log('fil777e', this.fileList);
      if (this.fileList.length > 0) {
        this.$message.warning(this.$t('home.fileMessageTwo'));
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('component.fileNoHt10MB'));
        return false;
      }
      // const isPDF = file.type === 'application/pdf';
      // if(this.isUplodFileType === 'pdf'){
      //   if (!isPDF) {
      //     this.$message.error('只能上传 PDF 文件');
      //     return false
      //   }
      // }
    },
    handleGetType: function handleGetType(row) {
      var lastDotIndex = row.fileName.lastIndexOf('.');
      // 截取从最后一个点开始到字符串末尾的部分
      var fileType = row.fileName.substring(lastDotIndex);
      row.fileType = fileType;
    },
    // 查看/下载附件
    handleView: function handleView(row) {
      console.log(row, 'row');
      //  this.handleGetType(row)
      //   const typePreview = '.png,.jpg,.pdf,.jpeg';
      // 预览
      (0, _booking.downloadFile)(row.fileKey).then(function (res) {
        var url = window.URL.createObjectURL(res);
        var elink = document.createElement('a');
        elink.style.display = 'none';
        elink.href = url;
        elink.setAttribute('download', row.fileName);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        //   if (typePreview.indexOf(row.fileType.toLowerCase()) > -1) {
        //   if (row.fileType.toLowerCase() !== '.pdf') {
        //     // 图片预览
        //     const i = (this.imgSrcList || []).findIndex(
        //       (item) => item.id === row.fileKey
        //     );
        //     if (i !== -1) {
        //       this.imgSrcList.splice(i, 1);
        //     }
        //     console.log(res, 'res')
        //     const urlObj = {
        //       isOrigin: false,
        //       id: row.fileKey,
        //       url: window.URL.createObjectURL(res)
        //     };
        //     this.imgSrcList.unshift(urlObj);
        //     this.isShow = true;
        //     } else {
        //       //pdf下载权限
        //       if( this.pdfPermit == 'disable' ||(this.pdfPermit && !this.btnPermissions.includes(this.pdfPermit))){
        //         this.downloadDisable = 'disable'
        //       }
        //       // pdf预览
        //       this.pdfTitle = row.fileName;
        //       this.pdfUrl =  window.URL.createObjectURL(res)
        //       console.log('pdfUrl',this.pdfUrl)
        //       this.pdfVisible = true;
        //     }
        //   } else {
        //   // 下载
        //   const url = window.URL.createObjectURL(res);
        //   const elink = document.createElement('a');
        //   elink.style.display = 'none';
        //   elink.href = url;
        //   elink.setAttribute('download', row.fileName);
        //   document.body.appendChild(elink);
        //   elink.click();
        //   document.body.removeChild(elink);
        // }
      });
    },
    // 删除附件
    handleDel: function handleDel(row) {
      var _this4 = this;
      this.$confirm(this.$t('home.deleteMessage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
        type: 'warning'
      }).then(function () {
        // deleteFile(row.fileKey).then((res) => {
        // if (res.success) {
        if (row.bkImoComFileId) {
          row.rowStatus = 8;
          _this4.deletefileKey.push(row);
        }
        _this4.fileList = [];
        _this4.$message.success(_this4.$t('home.deleteSuccess'));
        // } else {
        //   this.$message({
        //     message: res.errorMessages[0],
        //     type: 'error'
        //   });
        // }
        // });
      });
    },
    dateFormat: function dateFormat(row, column) {
      return (0, _utils.parseTime)(row.createTime, 'YYYY-MM-DD hh:mm');
    }
  }
};